namespace GeniuzPOS.Product {
    export interface PluDtRow {
        Id?: number;
        SkuCode?: string;
        PluCode?: string;
        PluDesc?: string;
        PluShortDesc?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SellUnit?: string;
        SellUnitRatio?: number;
        SellUnitPrice1?: number;
        SellUnitPrice2?: number;
        SellUnitPrice3?: number;
        SellUnitPrice4?: number;
        SellUnitPrice5?: number;
        SellUnitPrice6?: number;
        DeliverCost?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        PluName?: string;
        PluType?: PluTypeFg;
        ConceptCode?: string;
        ActiveSellFg?: number;
        ActiveRepFg?: number;
        IsActive?: number;
    }

    export namespace PluDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PluName';
        export const localTextPrefix = 'Product.PluDt';
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:สินค้า:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:สินค้า:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:สินค้า:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:สินค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            PluShortDesc = "PluShortDesc",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SellUnit = "SellUnit",
            SellUnitRatio = "SellUnitRatio",
            SellUnitPrice1 = "SellUnitPrice1",
            SellUnitPrice2 = "SellUnitPrice2",
            SellUnitPrice3 = "SellUnitPrice3",
            SellUnitPrice4 = "SellUnitPrice4",
            SellUnitPrice5 = "SellUnitPrice5",
            SellUnitPrice6 = "SellUnitPrice6",
            DeliverCost = "DeliverCost",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            PluName = "PluName",
            PluType = "PluType",
            ConceptCode = "ConceptCode",
            ActiveSellFg = "ActiveSellFg",
            ActiveRepFg = "ActiveRepFg",
            IsActive = "IsActive"
        }
    }
}
